import { Component, forwardRef, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormControl, ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, Validators } from '@angular/forms';

import { PageContentService, SessionStorageService, CommonService } from '../../core/index.service';
import { PageContent } from '../../core/index.model';

@Component({
    selector: 'pnx-time',
    templateUrl: 'time.control.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TimeControl), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => TimeControl), multi: true }
    ]
})
export class TimeControl implements OnChanges, ControlValueAccessor, Validator {
    @Input() labelId: string = '';
    @Input() defaultLabel: string = '';
    @Input() placeholderId: string = '';
    @Input() defaultPlaceholder: string = '';
    @Input() pagecontent: PageContent;

    @Input() timeformat: number = 12;
    @Input() mandatory: boolean = false;
    @Input() readonly: boolean = false;
    @Input() labelstyle: string = 'control-label';
    @Input() textcontainerstyle: string = 'col-md-9';
    @Input() textboxstyle: string = '';
    @Input() label: string = '';
    @Input() placeholder: string = '';
    @Input('value') _value = '';
    @Input() cleartextondisable: boolean = false;
    @Input() control: FormControl;
    @Input() disable: boolean = false;
    @Output() onChange: EventEmitter<any> = new EventEmitter<any>();
    
    disabled: boolean = false;
    Meridiem: string = '0';
        
    constructor(private pageContentService: PageContentService,
        private storageService: SessionStorageService,
        private commonService: CommonService) {
    }

    ngOnInit() {
        if (this.pagecontent) {
            if (!this.pageContentService.pageContent) {
                this.pageContentService.pageContent = this.pagecontent;
            }
        }
    }

    ngOnChanges(Changes: SimpleChanges) {
        if (Changes['disable']) {
            this.setDisabledState(Changes['disable'].currentValue);
        }

        this.onChangeCb(this.value);
        if (this.control) {
            this.validate(this.control);
        }
        
        let labelValue = (this.labelId) ? this.pageContentService.getKeyTxt(this.labelId, this.storageService.getLang()) : this.label;
        let placeHolderValue = (this.placeholderId) ? this.pageContentService.getKeyTxt(this.placeholderId, this.storageService.getLang()) : this.placeholder;

        this.label = (labelValue) ? labelValue : this.defaultLabel;
        this.placeholder = (placeHolderValue) ? placeHolderValue : this.defaultPlaceholder;
    }
    
    text = new FormControl();

    onChangeCb: (_: any) => void = () => { };

    get value() {
        return this._value;
    }

    set value(val) {
        if (val && (val.length == 4 || val.length == 5)) {
            var textdata;
            if (val.length == 4)
                textdata = val.toString().slice(0, 2) + ":" + val.toString().slice(2, 4);
            else if (val.length == 5)
                textdata = val;
            var data = this.commonService.get12HourFormat(textdata);
            this._value = data[0];
            //this.Meridiem = data[1]; //Commented for CRM#124128 when give time '12.00' changing to 'AM'
        }
        else {
            this._value = val;
            //this.Meridiem = '0';
        }
        this.onChangeCb(val);
    }

    onTextChange() {
        this.value = this.text.value;
        if (this.text.value && this.text.value.length == 4) {
            var textdata = this.text.value.toString().slice(0, 2) + ":" + this.text.value.toString().slice(2, 4);
            var input;
            if (this.Meridiem == '0')
                input = textdata.toString() + " AM";
            else
                input = textdata.toString() + " PM";

            var data = this.commonService.get24hourFormat(input);
            this.onChange.emit(data);
        }
        else {
            this.onChange.emit(this.value);
        }
    }

    onSelectChange(evnt: any) {
        this.value = this.text.value;
        var textval;
        if (this.text.value && this.text.value.length == 5) {
            textval = this.text.value.toString().replace(':', '');
        } else {
            textval = this.text.value;
        }
        if (textval && textval.length == 4) {
            var textdata = textval.toString().slice(0, 2) + ":" + textval.toString().slice(2, 4);
            var input;
            if (evnt.target.value == '0')
                input = textdata.toString() + " AM";
            else
                input = textdata.toString() + " PM";

            var data = this.commonService.get24hourFormat(input);
            this.onChange.emit(data);
        }        
        else {
            this.onChange.emit(this.value);
        }
    }
    
    writeValue(value): void {
        this.value = value;
        this.text.setValue(this.value);
    }

    registerOnChange(fn: any): void {
        this.onChangeCb = fn;
    }

    registerOnTouched(fn: any): void { }

    checkLength() {
        if (this.value && this.value.length < 4) {
            alert('Please enter valid time');
            this.text.reset('');
        }        
    }

    setMaxlength(evt: any) {

        let keyCode = parseInt(evt.keyCode);

        if (!this.value) {
            if (!this.isValidHours(keyCode)) {
                evt.preventDefault();
            }
        }
        else {
            if (!this.isValidHours(keyCode, this.value.length)) {

                if (!this.checkSpecialKeys(keyCode)) {
                    evt.preventDefault();
                }
            }
        }
    }
    
    checkSpecialKeys(keyCode: any): boolean {

        if (keyCode === 8 // backspace
            || keyCode === 9 // Tab
            || keyCode === 27 // escape
            || keyCode === 46 // delete
            || keyCode === 16 // shift
            || (keyCode >= 35 && keyCode <= 40)) // end, home, arrows

        {
            return true;
        }
        else {
            return false;
        }
    }
    
    isValidHours(keyCode: number, length: number =0): boolean {
        let returnValue:boolean =  false;
        
        if (this.timeformat == 12) {
            switch (length) {
                case 0://Allows Upto 1X:XX
                    {
                        returnValue = ((keyCode >= 48 && keyCode <= 49) || (keyCode >= 96 && keyCode <= 97)) ? true : false;
                    }
                    break;
                case 1:
                    {
                        if (this.value === '0') { //Allows Upto 09:XX
                            returnValue = ((keyCode >= 49 && keyCode <= 57) || (keyCode >= 97 && keyCode <= 105)) ? true : false;
                        }
                        else {//Allows Upto 12:XX
                            returnValue = ((keyCode >= 48 && keyCode <= 50) || (keyCode >= 96 && keyCode <= 98)) ? true : false;
                        }
                    }
                    break;
                case 2: //Allows Upto 12:5X
                    {
                        returnValue = ((keyCode >= 48 && keyCode <= 53) || (keyCode >= 96 && keyCode <= 101)) ? true : false;
                    }
                    break;
                default://Allows Upto 12:59
                    {
                        returnValue = true;
                    }
                    break;
            }
        }
        else if (this.timeformat == 24) {

            switch (length) {
                case 0://Allows Upto 2X:XX
                    {
                        returnValue = ((keyCode >= 48 && keyCode <= 50) || (keyCode >= 96 && keyCode <= 98)) ? true : false;
                    }
                    break;
                case 1://Allows Upto 23:XX
                    {
                        if (this.value === '0' || this.value === '1') { //Allows Upto 09:XX
                            returnValue = ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105)) ? true : false;
                        }
                        else {//Allows Upto 23:XX
                            returnValue = ((keyCode >= 48 && keyCode <= 51) || (keyCode >= 96 && keyCode <= 99)) ? true : false;
                        }
                    }
                    break;
                case 2://Allows Upto 23:5X
                    {
                        returnValue = ((keyCode >= 48 && keyCode <= 53) || (keyCode >= 96 && keyCode <= 101)) ? true : false;
                    }
                    break;
                default:
                    {
                        returnValue = true;
                    }
                    break;
            }
        }

        return returnValue;
    }
    
    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;

        if (!this.text.disabled && this.disabled && this.cleartextondisable) {
            this.value = '';
            this.text.setValue(this.value);
            this.text.disable();
        }
        else if (!this.text.disabled && this.disabled) {
            this.text.disable();
        }
        else if (this.text.disabled) {
            this.text.enable();
        }
    }

    public validate(parentControl: AbstractControl): { [key: string]: any } {

        const val = parentControl.value;

        if (this.mandatory) {

            this.text.setValidators([Validators.required, Validators.minLength(4)]);
            parentControl.setValidators([Validators.required, Validators.minLength(4)]);

            if (!parentControl.value) {
                parentControl.setValue(null);
            }

            if (!val) {
                return { valid: false };
            }
        }
        else {

            this.text.clearValidators();
            parentControl.clearValidators();

            if (!parentControl.value) {
                parentControl.setValue(null);
            }
        }

        return null;
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/time.control.ts